module.exports = __webpack_public_path__ + "img/xls.f0b6ad5c.png";